import React from 'react';
import { cn } from '../../utils/cn';

export interface CheckboxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  required?: boolean;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, required = false, ...props }, ref) => {
    return (
      <div className="flex items-center gap-3">
        <input
          type="checkbox"
          className={cn(
            'h-4 w-4 rounded border-2 border-muted text-accent focus:ring-primary',
            // Force the border color with important if needed
            '!border-muted',
            className
          )}
          ref={ref}
          {...props}
        />
        {label && (
          <label
            htmlFor={props.id}
            className="block text-base font-medium cursor-pointer"
          >
            {label}
            {required && <span className="text-[#F03434] ml-1">*</span>}
          </label>
        )}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export { Checkbox };
